import { apiGet } from '../http';

export default {
    async getAllCurrencyRatesAPI() {
        return await apiGet("api/currencyrates")
    },
    async getBoxLocationsAPI() {
        return await apiGet("api/boxlocation")
    },
    async getColorsAPI() {
        return await apiGet("api/colors")
    }
}